import moment from "moment";
import React, { useMemo } from "react";
import { ITimelineColumnProps } from "./TimelineColumn";
import { SmallBody } from "src/components/Text";
import { monthLangTags } from "../utils";
import localize from "src/l10n/localize";
import TimelineColumnBase from "./TimelineColumnBase";

const TimelineColumnMonth = (props: ITimelineColumnProps) => {
    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            year: m.format("YYYY"),
            monthName: localize(monthLangTags[m.month()]),
            isDecember: m.month() === 11,
            isJuly: m.month() === 6,
            isActive: m.isSame(moment(), 'month')
        }
    }, [props.item.startMilliseconds]);

    return (
        <TimelineColumnBase
            columnIndex={props.columnIndex}
            columnWidth={props.columnWidth}
            reportHeaderHeight={props.reportHeaderHeight}
            laneStyle={{ position: "relative" }}
            header={(
                <>
                    <div
                        className={[
                            "header-column",
                            data.isDecember ? "border-right" : "",
                        ].filter(x => !!x).join(" ")}
                        style={{
                            height: 32,
                            width: props.columnWidth,
                        }}>
                        <SmallBody>{data.isJuly && data.year}</SmallBody>
                    </div>
                    <div
                        className={[
                            "header-column",
                            "border-right",
                            (data.isActive ? " active" : "")
                        ].join(" ")}
                        style={{
                            width: props.columnWidth,
                            height: 36,
                        }}>
                        <div>
                            <SmallBody>{data.monthName}</SmallBody>
                        </div>
                    </div>
                </>
            )}
        />
    )
}

export default TimelineColumnMonth;
